/*
  cart-item-live-price.js

  Cart drawer line prices update the moment the shopper taps +/-.

  Without this the price only changes once /cart/change.js has answered and the
  whole drawer section is re-rendered, which reads as a blink. The unit prices
  are already on the element as data attributes, so the new line total can be
  worked out and painted immediately; the server response then confirms it with
  identical markup, so nothing visibly moves.
*/
(function () {
  'use strict';

  /* Shopify's money format strings, e.g. "QR {{amount_no_decimals}}". */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';

    function num(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return whole + cent;
    }

    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount':
        value = num(cents, 2);
        break;
      case 'amount_no_decimals':
        value = num(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = num(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = num(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = num(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = num(cents, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        value = num(cents, 2, ' ', ',');
        break;
      default:
        value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function priceBoxFor(el) {
    var row = el.closest('.cart-item');
    return row ? row.querySelector('[data-live-price]') : null;
  }

  function paint(box, qty) {
    if (!box || !(qty > 0)) return;

    var unit = parseInt(box.dataset.unitFinal, 10) || 0;
    var unitWas = parseInt(box.dataset.unitWas, 10) || 0;
    var withCode = box.dataset.currencyCodeEnabled === '1';
    var fmt = withCode ? box.dataset.moneyFormatCurrency : box.dataset.moneyFormat;

    var now = box.querySelector('.cdi__now');
    var was = box.querySelector('.cdi__was');

    if (now) now.textContent = formatMoney(unit * qty, fmt);
    if (was && unitWas > 0) was.textContent = formatMoney(unitWas * qty, fmt);

    /* Marks the row as ahead of the server so the re-render is not treated as
       a change by anything watching. */
    box.setAttribute('data-live-qty', qty);
  }

  function qtyOf(input) {
    var v = parseInt(input.value, 10);
    return isNaN(v) ? 0 : v;
  }

  /* +/- are buttons next to the input; the input itself also fires change. */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('cart-drawer .quantity__button');
      if (!btn) return;
      var wrap = btn.closest('quantity-input, .quantity');
      var input = wrap && wrap.querySelector('.quantity__input');
      if (!input) return;

      /* The theme updates the field on the same click; read it after. */
      setTimeout(function () {
        paint(priceBoxFor(input), qtyOf(input));
      }, 0);
    },
    true
  );

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('cart-drawer .quantity__input');
    if (!input) return;
    paint(priceBoxFor(input), qtyOf(input));
  });
})();
